<template>
  <div class="home">
    <welcome :title="title" :showBrugerInfo="true"/>
    <div
      v-if="loginProviderIsApi"
      class="login"
    >
      <div class="loginInner">
        <h2>Log ind</h2>
        <div>
          <label for="email">Email:</label>
          <input
            v-model="email"
            id="email"
            type="email"
            placeholder="Email"
          />
        </div>
        <div>
          <label for="pass">Password:</label>
          <input
            v-model="pass"
            id="pass"
            type="password"
            placeholder="Password"
          />
        </div>
        <div
          class="error"
          v-if="errorMessage !== ''"
        >{{ errorMessage }}
        </div>
        <button
          class="modal-default-button"
          @click="onLogin"
        >
          Log Ind
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/config';
import { signin } from '@/auth';
import Welcome from '@/components/Home/Welcome.vue';

export default {
  name: 'login',
  components: {
    Welcome,
  },
  data() {
    return {
      email: 'bruger1@herning.dk',
      pass: 'bruger1',
      errorMessage: ' ',
      loginProviderIsApi: config.auth.provider === 'api',
      title: process.env.VUE_APP_TITLE,
    };
  },
  methods: {
    onLogin() {
      this.errorMessage = ' ';
      signin(this.email, this.pass)
        .then(response => {
          if (response.token) {
            localStorage.setItem('token', response.token);
            this.$router.push({ name: 'home' });
          } else if (response.code && response.code === '28P01') {
            this.errorMessage = 'Ugyldig email eller password.'; // response message === invalid user or password
          } else {
            this.errorMessage = 'Login mislykkedes. Prøv igen.';
          }
        })
        .catch(error => {
          console.log(error);
          this.error = error.toString();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.login {
  width: 100%;
  padding-left: 565px;
  padding-top: 80px;
}

.loginInner {
  max-width: 500px;
  width: 80%;
  margin: 0 auto;
}

h2 {
  font-size: 20px;
  font-weight: 700;
}

.login label {
  display: block;
  width: 100px;
  font-size: 15px;
  padding: 8px 0;
  opacity: 0.7;
}

input {
  width: 100%;
  padding: 15px;
  font-size: 16px;
  border-radius: 3px;
  background: #f7f7fa;
  border: 1px solid #f7f7fa;
  margin-bottom: 16px;
  color: $primary-700;
  &:focus {
    border: 1px solid #6a72a6;
    outline: none;
  }
}

button {
  background-color: $primary-700;
  color: #ffffff;
  border: none;
  border-radius: 3px;
  padding: 0;
  font: inherit;
  cursor: pointer;
  width: 130px;
  height: 42px;
  font-weight: 600;
  &:hover {
    box-shadow: 0 2px 10px 0 rgba(15, 28, 112, 0.251);
  }
}
.error {
  color: red;
  height: 20px;
}

@media only screen and (max-width: $tablet-landscape-max-width),
  screen and (max-height: 800px) {
  .login {
    padding-left: 320px;
  }
}

@media only screen and (max-width: $tablet-max-width) {
  .login {
    padding: 30px 0;
  }
}
</style>
